import React from 'react'
import cx from 'classnames'
import SvgChevronUp from '../../../../views/components/atoms/Icons/Arrows/ChevronUp'
import SvgChevronDown from '../../../../views/components/atoms/Icons/Arrows/ChevronDown'
import { TSortableHeaderProps } from '../../../../views/components/organisms/Table/AggregateTable'
import styles from './LeaseTermHeader.module.scss'

type LeaseTermHeaderProps = TSortableHeaderProps & {
  startKey: string
  endKey: string
}

/**
 * The lease term column holds two dates, so it sorts on either one. Both choices stay on the
 * header rather than behind a menu, so the date the list is ordered by is always readable.
 */
const LeaseTermHeader = ({ sortKey, sortOrder, onSort, startKey, endKey }: LeaseTermHeaderProps) => (
  <div className={styles.root}>
    <span>Lease term</span>
    <div className={styles.toggle} role="group" aria-label="Sort lease term by">
      {[
        { key: startKey, label: 'Start' },
        { key: endKey, label: 'End' },
      ].map(({ key, label }) => {
        const isActive = sortKey === key

        return (
          <button
            key={key}
            type="button"
            aria-pressed={isActive}
            className={cx(styles.option, { [styles.active]: isActive })}
            onClick={() => onSort(key)}
          >
            {label}
            {isActive && (sortOrder === 'desc' ? <SvgChevronUp /> : <SvgChevronDown />)}
          </button>
        )
      })}
    </div>
  </div>
)

export default LeaseTermHeader
